import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/images/minicity_logo.png';
const _withScopeId = n => (_pushScopeId("data-v-8fd8ba02"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "container" };
const _hoisted_2 = { class: "headerRow level is-mobile" };
const _hoisted_3 = { class: "level-left" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    class: "headerLogo",
    src: _imports_0
}, null, -1));
const _hoisted_5 = {
    key: 0,
    class: "tag is-info is-rounded is-size-6 has-text-weight-bold ml-4"
};
const _hoisted_6 = {
    key: 1,
    class: "tag is-info is-rounded is-size-6 has-text-weight-bold ml-4"
};
const _hoisted_7 = { class: "level-right" };
const _hoisted_8 = { class: "headerUsernameSection" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
const _hoisted_10 = { class: "dropdown-trigger" };
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-user-circle fa-2x mx-3" }, null, -1));
const _hoisted_12 = [
    _hoisted_11
];
const _hoisted_13 = {
    class: "dropdown-menu",
    id: "dropdown-menu",
    role: "menu"
};
const _hoisted_14 = { class: "dropdown-content" };
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-cog mr-1" }, null, -1));
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("hr", { class: "dropdown-divider" }, null, -1));
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-sign-out-alt mr-1" }, null, -1));
const _hoisted_18 = { class: "tabsRow" };
const _hoisted_19 = {
    key: 0,
    style: { "display": "contents" }
};
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "icon is-small" }, [
    /*#__PURE__*/ _createElementVNode("i", {
        class: "fas fa-tasks",
        "aria-hidden": "true"
    })
], -1));
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("strong", null, "My Tasks", -1));
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "tabDivider" }, null, -1));
const _hoisted_23 = {
    key: 1,
    style: { "display": "contents" }
};
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "icon is-small" }, [
    /*#__PURE__*/ _createElementVNode("i", {
        class: "fas fa-city",
        "aria-hidden": "true"
    })
], -1));
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("strong", null, "Partners", -1));
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "icon is-small" }, [
    /*#__PURE__*/ _createElementVNode("i", {
        class: "fas fa-home",
        "aria-hidden": "true"
    })
], -1));
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("strong", null, "Sites", -1));
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "icon is-small" }, [
    /*#__PURE__*/ _createElementVNode("i", {
        class: "fas fa-user-circle",
        "aria-hidden": "true"
    })
], -1));
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("strong", null, "Caseworkers", -1));
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "tabDivider" }, null, -1));
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "icon is-small" }, [
    /*#__PURE__*/ _createElementVNode("i", {
        class: "fas fa-users",
        "aria-hidden": "true"
    })
], -1));
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("strong", null, "Citizens", -1));
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "icon is-small" }, [
    /*#__PURE__*/ _createElementVNode("i", {
        class: "fas fa-id-card",
        "aria-hidden": "true"
    })
], -1));
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("strong", null, "Birth Records", -1));
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "icon is-small" }, [
    /*#__PURE__*/ _createElementVNode("i", {
        class: "fas fa-address-card",
        "aria-hidden": "true"
    })
], -1));
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("strong", null, "Social Security", -1));
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "icon is-small" }, [
    /*#__PURE__*/ _createElementVNode("i", {
        class: "fas fa-medkit",
        "aria-hidden": "true"
    })
], -1));
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("strong", null, "Georgia Benefits", -1));
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "tabDivider" }, null, -1));
const _hoisted_40 = {
    key: 6,
    style: { "display": "contents" }
};
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("a", null, [
    /*#__PURE__*/ _createElementVNode("span", { class: "icon is-small" }, [
        /*#__PURE__*/ _createElementVNode("i", {
            class: "fas fa-envelope",
            "aria-hidden": "true"
        })
    ]),
    /*#__PURE__*/ _createElementVNode("strong", null, "Inbound Mail")
], -1));
const _hoisted_42 = [
    _hoisted_41
];
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "tabDivider" }, null, -1));
const _hoisted_44 = {
    key: 7,
    style: { "display": "contents" }
};
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("a", null, [
    /*#__PURE__*/ _createElementVNode("span", { class: "icon is-small" }, [
        /*#__PURE__*/ _createElementVNode("i", {
            class: "fas fa-chart-line",
            "aria-hidden": "true"
        })
    ]),
    /*#__PURE__*/ _createElementVNode("strong", null, "Analytics")
], -1));
const _hoisted_46 = [
    _hoisted_45
];
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "tabDivider" }, null, -1));
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("a", null, [
    /*#__PURE__*/ _createElementVNode("span", { class: "icon is-small" }, [
        /*#__PURE__*/ _createElementVNode("i", {
            class: "fas fa-question-circle",
            "aria-hidden": "true"
        })
    ]),
    /*#__PURE__*/ _createElementVNode("strong", null, "Help")
], -1));
const _hoisted_49 = [
    _hoisted_48
];
const _hoisted_50 = { class: "mainRow" };
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, [
    /*#__PURE__*/ _createTextVNode("Effective March 6, 2026, partner sites will continue to use Mini City to submit applications for Georgia benefits and vital records; however, "),
    /*#__PURE__*/ _createElementVNode("u", null, [
        /*#__PURE__*/ _createElementVNode("strong", null, "all application statuses, updates, approvals, or rejections will be routed directly to your organization's address we have on file.")
    ])
], -1));
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "During this period, Mini City will pause our direct outreach days and individualized case support while our leadership team pursues advanced public policy training to better address the systemic barriers impacting benefit access statewide.", -1));
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, [
    /*#__PURE__*/ _createTextVNode("Partner organizations whose partnerships began in 2024 or earlier have already operated under a Service-Only model and will experience minimal change. For teams onboarding new staff or seeking refresher guidance, Mini City will provide one complimentary virtual software training session. Additional trainings may be scheduled at a standard service rate. Please contact "),
    /*#__PURE__*/ _createElementVNode("strong", null, "hello@minicityatl.com"),
    /*#__PURE__*/ _createTextVNode(" for training requests and pricing information.")
], -1));
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "We are deeply grateful for your partnership and will notify you when full-service operations resume.", -1));
import App from '@/App.vue';
import { CONFIG, Environment, STATIC_CONFIG } from '@/core/config';
import { canSeeFeature, endSession, isFeatureEnabled, isNetworkAdmin, sessionState } from "@/core/session";
import OpenTasksIndicator from '@/features/tasks/OpenTasksIndicator.vue';
import { Feature, User, Core } from '@minicity/core';
import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";
const autoLogoutDelayMillis = 10 * 60 * 1000; // 10 minutes
export default /*#__PURE__*/ _defineComponent({
    __name: 'Main',
    setup(__props) {
        let shouldShowModal = true;
        // Show modal every day until the end of summer
        const currentDate = new Date().toISOString().substring(0, "YYYY-MM-DD".length);
        const lastDismissed = localStorage.getItem("hideServiceOnlyModal");
        if (lastDismissed && lastDismissed == currentDate) {
            shouldShowModal = false;
        }
        if (lastDismissed && new Date().getTime() > new Date("2026-07-31").getTime()) {
            shouldShowModal = false;
        }
        const showServiceOnlyModal = ref(shouldShowModal);
        const hideServiceOnlyModal = () => {
            showServiceOnlyModal.value = false;
            localStorage.setItem("hideServiceOnlyModal", currentDate);
        };
        // Determine active tab based on first part of URL path
        const activeTab = ref(useRoute().path.split('/')[1]);
        const changeTab = (tabId) => {
            activeTab.value = tabId;
            router.push("/" + tabId);
        };
        const router = useRouter();
        if (!sessionState.session) {
            // Redirect to login
            router.push(`/login?forwardTo=${encodeURIComponent(document.location.pathname + document.location.search)}`);
        }
        else if (activeTab.value == "") {
            // Show default tab
            changeTab(isFeatureEnabled(Feature.Type.TASKS) ? "tasks" : "citizens");
        }
        const hamburgerOpen = ref(false);
        const showHelp = () => {
            window.open(CONFIG.value.helpUrl);
        };
        const logout = (isAutoLogout) => {
            clearTimeout(App.$autoLogoutTimer);
            endSession();
            router.push(isAutoLogout ? `/login?autoLogout=true&forwardTo=${encodeURIComponent(document.location.pathname + document.location.search)}` : "/login");
        };
        let autoLogoutLastActive = 0;
        const resetAutoLogoutTimer = () => {
            clearTimeout(App.$autoLogoutTimer);
            if (sessionState.session && localStorage["autoLogoutSessionId"] == sessionState.session.id) {
                // Another tab has already auto-logged us out
                console.log("Logged out by other tab");
                logout(true);
            }
            // Periodically update the "last active" time localStorage variable, to signal to other tabs that the user is still active
            const currentTime = new Date().getTime();
            if (currentTime - autoLogoutLastActive > 10000) {
                localStorage["autoLogoutLastActive"] = currentTime;
                autoLogoutLastActive = currentTime;
            }
            App.$autoLogoutTimer = setTimeout(() => {
                var _a;
                // If another tab is active and "keeping the session alive", we don't want to log the user out
                const millisSinceLastActive = new Date().getTime() - Number(localStorage["autoLogoutLastActive"]);
                if (millisSinceLastActive < autoLogoutDelayMillis)
                    return;
                console.log("Auto-logout triggered");
                localStorage["autoLogoutSessionId"] = (_a = sessionState.session) === null || _a === void 0 ? void 0 : _a.id;
                logout(true);
            }, autoLogoutDelayMillis);
        };
        resetAutoLogoutTimer();
        document.onmousemove = resetAutoLogoutTimer;
        document.onkeypress = resetAutoLogoutTimer;
        return (_ctx, _cache) => {
            var _a, _b, _c, _d;
            const _component_router_link = _resolveComponent("router-link");
            const _component_router_view = _resolveComponent("router-view");
            const _component_ModalDialog = _resolveComponent("ModalDialog");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _hoisted_4,
                        (_unref(STATIC_CONFIG).ENV == _unref(Environment).TEST)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Test Environment"))
                            : _createCommentVNode("", true),
                        (_unref(STATIC_CONFIG).ENV == _unref(Environment).DEV)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Dev Environment"))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("span", null, [
                                _createElementVNode("strong", null, _toDisplayString((_b = (_a = _unref(sessionState)) === null || _a === void 0 ? void 0 : _a.session) === null || _b === void 0 ? void 0 : _b.user.displayName), 1)
                            ]),
                            _hoisted_9,
                            _createElementVNode("span", null, _toDisplayString(_unref(User).Role_Label[(_d = (_c = _unref(sessionState)) === null || _c === void 0 ? void 0 : _c.session) === null || _d === void 0 ? void 0 : _d.user.role]), 1)
                        ]),
                        _createElementVNode("div", {
                            class: _normalizeClass(["dropdown is-right is-vcentered", { 'is-active': hamburgerOpen.value }])
                        }, [
                            _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("a", {
                                    "aria-haspopup": "true",
                                    "aria-controls": "dropdown-menu",
                                    onClick: _cache[0] || (_cache[0] = ($event) => (hamburgerOpen.value = !hamburgerOpen.value))
                                }, _hoisted_12)
                            ]),
                            _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("div", _hoisted_14, [
                                    _createVNode(_component_router_link, {
                                        to: "/userSettings",
                                        class: "dropdown-item"
                                    }, {
                                        default: _withCtx(() => [
                                            _hoisted_15,
                                            _createTextVNode(" Your Settings ")
                                        ]),
                                        _: 1
                                    }),
                                    _hoisted_16,
                                    _createElementVNode("a", {
                                        class: "dropdown-item",
                                        onClick: _cache[1] || (_cache[1] = ($event) => (logout(false)))
                                    }, [
                                        _hoisted_17,
                                        _createTextVNode(" Logout ")
                                    ])
                                ])
                            ])
                        ], 2)
                    ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", {
                        class: _normalizeClass(["tabs is-boxed", { 'is-small': _unref(isNetworkAdmin)() }])
                    }, [
                        _createElementVNode("ul", null, [
                            (_unref(canSeeFeature)('tasks'))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                    _createElementVNode("li", {
                                        class: _normalizeClass({ 'is-active': activeTab.value == 'tasks' }),
                                        onClick: _cache[2] || (_cache[2] = ($event) => (changeTab('tasks')))
                                    }, [
                                        _createElementVNode("a", null, [
                                            _hoisted_20,
                                            _hoisted_21,
                                            _createVNode(OpenTasksIndicator)
                                        ])
                                    ], 2),
                                    _hoisted_22
                                ]))
                                : _createCommentVNode("", true),
                            (_unref(canSeeFeature)('sites'))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                    (_unref(canSeeFeature)('partners'))
                                        ? (_openBlock(), _createElementBlock("li", {
                                            key: 0,
                                            class: _normalizeClass({ 'is-active': activeTab.value == 'partners' }),
                                            onClick: _cache[3] || (_cache[3] = ($event) => (changeTab('partners')))
                                        }, [
                                            _createElementVNode("a", null, [
                                                _hoisted_24,
                                                _hoisted_25,
                                                _createVNode(OpenTasksIndicator, {
                                                    entityType: _unref(Core).EntityType['Partner']
                                                }, null, 8, ["entityType"])
                                            ])
                                        ], 2))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("li", {
                                        class: _normalizeClass({ 'is-active': activeTab.value == 'sites' }),
                                        onClick: _cache[4] || (_cache[4] = ($event) => (changeTab('sites')))
                                    }, [
                                        _createElementVNode("a", null, [
                                            _hoisted_26,
                                            _hoisted_27,
                                            _createVNode(OpenTasksIndicator, {
                                                entityType: _unref(Core).EntityType['Partner Site']
                                            }, null, 8, ["entityType"])
                                        ])
                                    ], 2),
                                    _createElementVNode("li", {
                                        class: _normalizeClass({ 'is-active': activeTab.value == 'partnerUsers' }),
                                        onClick: _cache[5] || (_cache[5] = ($event) => (changeTab('partnerUsers')))
                                    }, [
                                        _createElementVNode("a", null, [
                                            _hoisted_28,
                                            _hoisted_29,
                                            _createVNode(OpenTasksIndicator, {
                                                entityType: _unref(Core).EntityType['Partner User']
                                            }, null, 8, ["entityType"])
                                        ])
                                    ], 2),
                                    _hoisted_30
                                ]))
                                : _createCommentVNode("", true),
                            (_unref(canSeeFeature)('citizens'))
                                ? (_openBlock(), _createElementBlock("li", {
                                    key: 2,
                                    class: _normalizeClass({ 'is-active': activeTab.value == 'citizens' }),
                                    onClick: _cache[6] || (_cache[6] = ($event) => (changeTab('citizens')))
                                }, [
                                    _createElementVNode("a", null, [
                                        _hoisted_31,
                                        _hoisted_32,
                                        _createVNode(OpenTasksIndicator, {
                                            entityType: _unref(Core).EntityType['Citizen']
                                        }, null, 8, ["entityType"])
                                    ])
                                ], 2))
                                : _createCommentVNode("", true),
                            (_unref(canSeeFeature)('birthRecords'))
                                ? (_openBlock(), _createElementBlock("li", {
                                    key: 3,
                                    class: _normalizeClass({ 'is-active': activeTab.value == 'birthRecords' }),
                                    onClick: _cache[7] || (_cache[7] = ($event) => (changeTab('birthRecords')))
                                }, [
                                    _createElementVNode("a", null, [
                                        _hoisted_33,
                                        _hoisted_34,
                                        _createVNode(OpenTasksIndicator, {
                                            entityType: _unref(Core).EntityType['Birth Record']
                                        }, null, 8, ["entityType"])
                                    ])
                                ], 2))
                                : _createCommentVNode("", true),
                            (_unref(canSeeFeature)('socialSecurity'))
                                ? (_openBlock(), _createElementBlock("li", {
                                    key: 4,
                                    class: _normalizeClass({ 'is-active': activeTab.value == 'socialSecurity' }),
                                    onClick: _cache[8] || (_cache[8] = ($event) => (changeTab('socialSecurity')))
                                }, [
                                    _createElementVNode("a", null, [
                                        _hoisted_35,
                                        _hoisted_36,
                                        _createVNode(OpenTasksIndicator, {
                                            entityType: _unref(Core).EntityType['Social Security']
                                        }, null, 8, ["entityType"])
                                    ])
                                ], 2))
                                : _createCommentVNode("", true),
                            (_unref(canSeeFeature)('georgiaBenefits'))
                                ? (_openBlock(), _createElementBlock("li", {
                                    key: 5,
                                    class: _normalizeClass({ 'is-active': activeTab.value == 'georgiaBenefits' }),
                                    onClick: _cache[9] || (_cache[9] = ($event) => (changeTab('georgiaBenefits')))
                                }, [
                                    _createElementVNode("a", null, [
                                        _hoisted_37,
                                        _hoisted_38,
                                        _createVNode(OpenTasksIndicator, {
                                            entityType: _unref(Core).EntityType['Georgia DFCS Benefits']
                                        }, null, 8, ["entityType"])
                                    ])
                                ], 2))
                                : _createCommentVNode("", true),
                            _hoisted_39,
                            (_unref(canSeeFeature)('inboundMail'))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                    _createElementVNode("li", {
                                        class: _normalizeClass({ 'is-active': activeTab.value == 'inboundMail' }),
                                        onClick: _cache[10] || (_cache[10] = ($event) => (changeTab('inboundMail')))
                                    }, _hoisted_42, 2),
                                    _hoisted_43
                                ]))
                                : _createCommentVNode("", true),
                            (_unref(canSeeFeature)('analytics'))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                    _createElementVNode("li", {
                                        class: _normalizeClass({ 'is-active': activeTab.value == 'citizenAnalytics' }),
                                        onClick: _cache[11] || (_cache[11] = ($event) => (changeTab('citizenAnalytics')))
                                    }, _hoisted_46, 2),
                                    _hoisted_47
                                ]))
                                : _createCommentVNode("", true),
                            _createElementVNode("li", {
                                class: _normalizeClass({ 'is-active': activeTab.value == 'help' }),
                                onClick: _cache[12] || (_cache[12] = ($event) => (showHelp()))
                            }, _hoisted_49, 2)
                        ])
                    ], 2)
                ]),
                _createElementVNode("div", _hoisted_50, [
                    (_openBlock(), _createBlock(_component_router_view, {
                        key: _ctx.$route.fullPath
                    }))
                ]),
                (_unref(STATIC_CONFIG).SERVICE_ONLY_MODE)
                    ? (_openBlock(), _createBlock(_component_ModalDialog, {
                        key: 0,
                        active: showServiceOnlyModal.value,
                        title: "Mini City is transitioning to Service-Only Mode",
                        "allow-close": true,
                        onClose: _cache[13] || (_cache[13] = ($event) => (hideServiceOnlyModal())),
                        "first-button-text": "Confirm",
                        "first-button-severity": "link",
                        onFirstbuttonselected: _cache[14] || (_cache[14] = ($event) => (hideServiceOnlyModal()))
                    }, {
                        default: _withCtx(() => [
                            _hoisted_51,
                            _hoisted_52,
                            _hoisted_53,
                            _hoisted_54,
                            _hoisted_55,
                            _hoisted_56,
                            _hoisted_57
                        ]),
                        _: 1
                    }, 8, ["active"]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
